import ApiService from "../../ApiService";
import AppConfig from "../../../config/AppConfig";

const PracticeResultService = {
    loadScreenView: (userHomeworkUnitId, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/practiceresult/loadscreenview", { userHomeworkUnitId }, successCallback, failureCallback);
    },
    generateBySentence: (wordList, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/practiceresult/generatetranslations", { wordList }, successCallback, failureCallback);
    },
    updateUnitResult: (unitResult, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("clientType", 1);
        formData.append("clientVersion", AppConfig.APP_CLIENT_VERSION);
        formData.append("clientBuild", AppConfig.APP_CLIENT_BUILD);
        formData.append("unitResult", unitResult);

        ApiService.post("/mobile/homework/practiceresult/updateunitresult", formData, successCallback, failureCallback);
    },
};

export default PracticeResultService;
